




import Enumerable from "linq";
import { Mixins, Component } from "vue-property-decorator";
import { ModelEditableMixin, ModalPresentableMixin } from "../../../../../../base/components/system";
import { ObjectUtility } from "../../../../../../base/utilities";
import { GraphKinds, TextObjectKinds } from "../../../../../../documaker/domain/format/objects";
import { FormatPageStructureEditableMixin } from "../../mixins";
import {
  FormatPageStructureEditor,
  IFormatObjectEditable,
  IEditableFormatObject,
} from "../../../../../domain/editableFormat";
import { GraphObjectEditor } from "../../../../../domain/editableFormat/objectEditors";
import {
  IGraphObject, instanceOfIGraphObject,
  ITextObject, instanceOfITextObject,
} from "../../../../../domain/editableFormat/objects";
import { instanceOfIRangeOfMotionGroupKeyPropertyEditable } from "../../../../../domain/editableFormat/properties";

@Component
export default class RangeOfMotionGroupEditor extends Mixins(ModelEditableMixin, ModalPresentableMixin, FormatPageStructureEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: FormatPageStructureEditor) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: FormatPageStructureEditor) => T, defaultValue: T) => T;

  getSelectedGroupIds(): number[] {
    return this.extractGroupIds(this.selectedObjects);
  }

  extractGroupIds(objects: (IFormatObjectEditable | IEditableFormatObject)[]): number[] {
    return Enumerable.from(objects)
      .select(o => this.toGroupId(o))
      .where(o => typeof o === "number")
      .distinct()
      .toArray();
  }

  toGroupId(object: IFormatObjectEditable | IEditableFormatObject): number {
    return instanceOfIRangeOfMotionGroupKeyPropertyEditable(object)
      ? this.toRangeOfMotionGroupId(object.rangeOfMotionGroupKey().getValue())
      : (((instanceOfIGraphObject(object) && (object.kind === GraphKinds.RangeOfMotion)) || (instanceOfITextObject(object) && (object.objectKind === TextObjectKinds.RangeOfMotion))) ? this.toRangeOfMotionGroupId(object.name) : null);
  }

  createNewRangeOfMotionObjects(editor: GraphObjectEditor): IFormatObjectEditable[] {
    const uniqueId = this.createNewGroupId();
    const objects = [this.createNewRangeOfMotionGraph(editor, uniqueId)];
    for (let i = 1; i <= 4; i++) {
      objects.push(this.createNewRangeOfMotionText(editor, uniqueId, i));
    }
    return objects;
  }

  toRangeOfMotionGroupId(key: string): number {
    const regExp = /graph_([0-9]+)\[[0-4]\]/.exec(key);
    return !!regExp && regExp.length === 2 && !isNaN(parseInt(regExp[1], 10))
      ? parseInt(regExp[1], 10)
      : null;
  }

  toRangeOfMotionIndex(key: string): number {
    const regExp = /graph_[0-9]+\[([0-4])\]/.exec(key);
    return !!regExp && regExp.length === 2 && !isNaN(parseInt(regExp[1], 10))
      ? parseInt(regExp[1], 10)
      : null;
  }

  createNewGroupId(): number {
    const enumerable = Enumerable.from(this.objects)
      .select(o => o instanceof GraphObjectEditor ? this.toRangeOfMotionGroupId(o.rangeOfMotionGroupKey().getValue()) : null)
      .where(o => typeof o === "number");
    return enumerable.count() > 0
      ? enumerable.max() + 1
      : 0;
  }

  private createGroupKey(uniqueId: number, index: number): string {
    return "graph_" + uniqueId + "[" + index + "]";
  }

  private createNewRangeOfMotionGraph(editor: GraphObjectEditor, uniqueId: number): IFormatObjectEditable {
    const source = ObjectUtility.copyDeeply(editor.getSource()) as IGraphObject;
    source.name = this.createGroupKey(uniqueId, 0);
    return this.readPropertyOrDefault(s => s.createNewObject(source), null);
  }

  private createNewRangeOfMotionText(editor: GraphObjectEditor, uniqueId: number, index: number): IFormatObjectEditable {
    const source = ObjectUtility.copyDeeply(this.readPropertyOrDefault(s => s.createNewObject("NewRangeOfMotionText"), null).getSource()) as ITextObject;
    source.informationKey = this.createGroupKey(uniqueId, index);
    source.objectKind = TextObjectKinds.RangeOfMotion;
    source.size = { width: 25, height: 25 };
    const location = editor.location().getValue();
    const size = editor.size().getValue();
    switch (index) {
      case 1:
        source.location = { x: location.x - 30, y: location.y };
        source.printBehavior.shouldPrint = true;
        break;
      case 2:
        source.location = { x: location.x + size.width + 5, y: location.y };
        source.printBehavior.shouldPrint = true;
        break;
      case 3:
        source.location = { x: location.x, y: location.y + size.height + 5 };
        source.printBehavior.shouldPrint = false;
        source.printBehavior.shouldPreview = false;
        break;
      case 4:
        source.location = { x: location.x + size.width - 25, y: location.y + size.height + 5 };
        source.printBehavior.shouldPrint = false;
        source.printBehavior.shouldPreview = false;
        break;
    }
    return this.readPropertyOrDefault(s => s.createNewObject(source), null);
  }
}
